const isRegularLineItem = (lineItem)=>'productImage' in lineItem && typeof lineItem.productImage !== 'undefined'
;
const isContactLensesBundleLineItem = (lineItem)=>'type' in lineItem && lineItem.type === 'CONTACT_LENS_BUNDLE'
;
const isContactLensesLineItem = (lineItem)=>'type' in lineItem && lineItem.type === 'CONTACT_LENSES'
;
const isGlassesBundleLineItem = (lineItem)=>'type' in lineItem && lineItem.type === 'GLASSES_BUNDLE'
;

export { isContactLensesBundleLineItem, isContactLensesLineItem, isGlassesBundleLineItem, isRegularLineItem };
//# sourceMappingURL=line-items.js.map
